module.exports = __webpack_public_path__ + "static/img/p5-1-4-hover.61ebb26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/p5-1-4-hover.png
// module id = MErB
// module chunks = 1